<template>
	<div v-if="true">
		<DisplaySurvey :surveyContent="surveyContent"></DisplaySurvey>
	</div>
</template>
<script>
export default{
	name: "SurveyPreview",
	props: {
		survey: {type: Object},
		elements: {type: Object}
	},
	computed: {
		surveyContent: function(){
			return {
				
				elements: this.elements
			}
		}
	},
	components: {
		DisplaySurvey:  () => import("../../tools/DisplaySurvey")
	},
}
</script>